
import pageMixin from '@bkwld/cloak/mixins/page'
import getCraftPages from '~/queries/craft-pages.gql'
export default

	mixins: [ pageMixin ]

	props: ['error']

	data: -> page: null

	fetch: ->

		# Get get the page data
		[ @page ] = await @$craft.getEntries
			query: getCraftPages
			variables:
				section: 'towers'
				type: 'towers'
				uri: @uri

		# Assume a light marquee
		@$store.commit 'tower/setLightMarquee', true

	mounted: -> @showSentryDialog() if @uri == '500'

	computed:

		# Figure out which error tower to show
		uri: -> switch @error?.statusCode
			when 404 then '404'
			else '500'

	methods:

		# Show the sentry dialog
		# https://docs.sentry.io/enriching-error-data/user-feedback/?platform=browser
		showSentryDialog: -> @$defer => @$sentry?.showReportDialog()

